import { useDeviceMode } from '../../hooks/useDeviceMode';
import PublicDesktopLayout from '../public/PublicDesktopLayout';
import PublicMobileNativeLayout from '../public/PublicMobileNativeLayout';

export function PublicLayout() {
  const { isMobile } = useDeviceMode();

  if (isMobile) {
    return <PublicMobileNativeLayout />;
  }

  return <PublicDesktopLayout />;
}